import styled from 'styled-components';
import { upTo } from 'js/services/MediaQuery';

export const breakpoint = 'lg';

export default styled.div`
  min-height: 100%;

  & > div {
    min-height: 100%;
    display: grid;
  }
`;
